import * as React from 'react';

import { StationDirectionsContainer } from './directions/container';
import { StationListContainer } from './list/container';

export const Stations = () => (
  <>
    <StationDirectionsContainer />
    <StationListContainer />
  </>
);
